const Parser = {
  phone: (value) => {
    // Remove todos os caracteres não numéricos, exceto o prefixo +55
    const phoneNumber = value.replace(/[^\d]/g, "").slice(2);

    // Adiciona o código de país +55 e formata conforme a máscara desejada
    const match = phoneNumber.match(/^(\d{2})(\d{1})(\d{4})(\d{4})$/);

      if (match) {
      return `+55 (${match[1]}) ${match[2]} ${match[3]}-${match[4]}`;
    } else if (phoneNumber.length <= 2) {
      return `+55 (${phoneNumber}`;
    } else if (phoneNumber.length <= 3) {
      return `+55 (${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(2)}`;
    } else if (phoneNumber.length <= 7) {
      return `+55 (${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(
        2,
        3
      )} ${phoneNumber.slice(3)}`;
    } else {
      return `+55 (${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(
        2,
        3
      )} ${phoneNumber.slice(3, 7)}-${phoneNumber.slice(7, 11)}`;
    }
  },

  cpf(value) {
    if (!value) return value;
    const digits = value.replace(/\D/g, "").slice(0, 11);

    if (digits.length <= 3) {
      return digits;
    } else if (digits.length <= 6) {
      return `${digits.slice(0, 3)}.${digits.slice(3)}`;
    } else if (digits.length <= 9) {
      return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
    } else {
      return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
    }
  },

  cnpj(value) {
    if (!value) return value;
    const digits = value.replace(/\D/g, "").slice(0, 14);

    if (digits.length <= 2) {
      return digits;
    } else if (digits.length <= 5) {
      return `${digits.slice(0, 2)}.${digits.slice(2)}`;
    } else if (digits.length <= 8) {
      return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5)}`;
    } else if (digits.length <= 12) {
      return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8)}`;
    } else {
      return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12)}`;
    }
  },

  email(value) {
    if (!value) return value;
    // Just return lowercase email as-is
    return value.toLowerCase().trim();
  },

  number(value) {
    if (value < 10000) {
      return value.toLocaleString("pt-BR");
    } else if (value < 1000000) {
      const truncated = Math.floor(value / 100) / 10; // ex: 953256 -> 9532.56 -> 953.2
      return `${truncated.toString().replace(".", ",")}k`.replace(",", ".");
    } else {
      const truncated = Math.floor(value / 10000) / 100; // ex: 1789502 -> 17895.02 -> 1.78
      return `${truncated.toString().replace(".", ",")}M`.replace(",", ".");
    }
  },

  date: {
    ddmmyyyy: (value) => {
      return value.split("-").reverse().join("/");
    },
    readable: (value) => {
      if (!value) return '';
      const date = new Date(value);
      return date.toLocaleDateString('pt-BR', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      }) + ' às ' + date.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    ago: (value) => {
      if (!value) return '';

      const inputDate = new Date(value);
      const now = new Date();

      // Verificar se a data é válida
      if (isNaN(inputDate.getTime())) return '';

      // Calcular diferença em milissegundos
      const diffMs = now.getTime() - inputDate.getTime();
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

      // Verificar se é hoje (mesmo dia)
      const isToday = inputDate.toDateString() === now.toDateString();
      if (isToday) return 'hoje';

      // Verificar se é ontem
      const yesterday = new Date(now);
      yesterday.setDate(yesterday.getDate() - 1);
      const isYesterday = inputDate.toDateString() === yesterday.toDateString();
      if (isYesterday) return 'ontem';

      // Verificar se é nos últimos 7 dias
      if (diffDays < 7) return 'esta semana';

      // A menos de 30 dias
      if (diffDays <= 30) return `${diffDays} dias atrás`;

      // Calcular meses
      const diffMonths = Math.floor(diffDays / 30);

      // Mais de 30 dias e menos de 1 ano
      if (diffMonths < 12) {
        return diffMonths === 1 ? '1 mês atrás' : `${diffMonths} meses atrás`;
      }

      // Calcular anos
      const diffYears = Math.floor(diffDays / 365);

      // Mais de 1 ano e menos de 2
      if (diffYears === 1) return '1 ano atrás';

      // 2 anos ou mais
      return `${diffYears} anos atrás`;
    }
  },

  price: {
    brl: (cents) => {
      if (!cents) return cents;
      cents = parseInt(cents)
      const numericValue = `${cents}`?.replace(/\D/g, "");
      const integerPart = numericValue.slice(0, -2)?.replace(/^0+/, "") || "0";
      const decimalPart = numericValue.slice(-2);

      const formattedInteger = integerPart.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        "."
      );

      return `${formattedInteger},${decimalPart}`;
    },
  },

  interval: {
    adjective: (interval) => {
      return {
        week: "Semanal",
        month: "Mensal",
        bimonthly: "Bimestral",
        quarterly: "Trimestral",
        semiannual: "Semestral",
        year: "Anual",
        lifetime: "Vitalício",
      }[interval];
    },
    noun: (interval) => {
      return {
        week: "Semana",
        month: "Mês",
        bimonthly: "Bimestre",
        quarterly: "Trimestre",
        semiannual: "Semestre",
        year: "Ano",
        lifetime: "Vitalício",
      }[interval];
    },
  },


  payment: {
    chargeStatus(status) {
      return {
        'paid': 'Pago',
        'pending': 'Pendente',
        'processing': 'Processando',
        'canceled': 'Cancelado',
        'refunded': 'Reembolsado',
        'default': 'Desconhecido'
      }[status || 'default'];
    },
    subscriptionStatus(status) {
      return {
        'active': 'Ativa',
        'canceled': 'Cancelada',
        'expired': 'Expirada',
        'unknown': 'Pendente'
      }[status || 'unknown'];
    }
  },
  getCountryIso(value) {
    if (!value) return "un";

    // Comprehensive ITU calling code → ISO 3166-1 alpha-2 map.
    // Longer codes (e.g. 1242 for Bahamas) must be listed before their prefix (1 → us)
    // so that longest-prefix matching works correctly for raw string inputs.
    const callingCodeToIso = {
      // +1 NANP — specific country codes first, then US fallback
      1242: "bs", 1246: "bb", 1264: "ai", 1268: "ag", 1284: "vg",
      1340: "vi", 1345: "ky", 1441: "bm", 1473: "gd", 1649: "tc",
      1664: "ms", 1670: "mp", 1671: "gu", 1684: "as", 1721: "sx",
      1758: "lc", 1767: "dm", 1784: "vc", 1787: "pr", 1809: "do",
      1829: "do", 1849: "do", 1868: "tt", 1869: "kn", 1876: "jm",
      1939: "pr",
      1: "us",
      // Russia / Kazakhstan
      7: "ru",
      // Africa / Middle East (20–299)
      20: "eg", 27: "za",
      30: "gr", 31: "nl", 32: "be", 33: "fr", 34: "es", 36: "hu",
      39: "it", 40: "ro", 41: "ch", 43: "at", 44: "gb", 45: "dk",
      46: "se", 47: "no", 48: "pl", 49: "de",
      51: "pe", 52: "mx", 53: "cu", 54: "ar", 55: "br", 56: "cl",
      57: "co", 58: "ve",
      60: "my", 61: "au", 62: "id", 63: "ph", 64: "nz", 65: "sg",
      66: "th",
      81: "jp", 82: "kr", 84: "vn", 86: "cn",
      90: "tr", 91: "in", 92: "pk", 93: "af", 94: "lk", 95: "mm",
      98: "ir",
      212: "ma", 213: "dz", 216: "tn", 218: "ly",
      220: "gm", 221: "sn", 222: "mr", 223: "ml", 224: "gn",
      225: "ci", 226: "bf", 227: "ne", 228: "tg", 229: "bj",
      230: "mu", 231: "lr", 232: "sl", 233: "gh", 234: "ng",
      235: "td", 236: "cf", 237: "cm", 238: "cv", 239: "st",
      240: "gq", 241: "ga", 242: "cg", 243: "cd", 244: "ao",
      245: "gw", 248: "sc", 249: "sd", 250: "rw", 251: "et",
      252: "so", 253: "dj", 254: "ke", 255: "tz", 256: "ug",
      257: "bi", 258: "mz", 260: "zm", 261: "mg", 262: "re",
      263: "zw", 264: "na", 265: "mw", 266: "ls", 267: "bw",
      268: "sz", 269: "km", 290: "sh", 291: "er",
      297: "aw", 298: "fo", 299: "gl",
      350: "gi", 351: "pt", 352: "lu", 353: "ie", 354: "is",
      355: "al", 356: "mt", 357: "cy", 358: "fi", 359: "bg",
      370: "lt", 371: "lv", 372: "ee", 373: "md", 374: "am",
      375: "by", 376: "ad", 377: "mc", 378: "sm", 380: "ua",
      381: "rs", 382: "me", 385: "hr", 386: "si", 387: "ba",
      389: "mk",
      420: "cz", 421: "sk", 423: "li",
      500: "fk", 501: "bz", 502: "gt", 503: "sv", 504: "hn",
      505: "ni", 506: "cr", 507: "pa", 508: "pm", 509: "ht",
      590: "gp", 591: "bo", 592: "gy", 593: "ec", 594: "gf",
      595: "py", 596: "mq", 597: "sr", 598: "uy", 599: "cw",
      670: "tl", 673: "bn", 674: "nr", 675: "pg", 676: "to",
      677: "sb", 678: "vu", 679: "fj", 680: "pw", 681: "wf",
      682: "ck", 685: "ws", 686: "ki", 687: "nc", 688: "tv",
      689: "pf", 691: "fm", 692: "mh",
      850: "kp", 852: "hk", 853: "mo", 855: "kh", 856: "la",
      880: "bd", 886: "tw",
      960: "mv", 961: "lb", 962: "jo", 963: "sy", 964: "iq",
      965: "kw", 966: "sa", 967: "ye", 968: "om", 970: "ps",
      971: "ae", 972: "il", 973: "bh", 974: "qa", 975: "bt",
      976: "mn", 977: "np",
      992: "tj", 993: "tm", 994: "az", 995: "ge", 996: "kg",
      998: "uz",
    };

    let code;
    if (typeof value === "object") {
      code = String(value.areaCode || "55");
    } else {
      // Raw phone string: try longest prefix match (4 → 3 → 2 → 1 digits)
      const digits = value.replace(/\D/g, "");
      code = [4, 3, 2, 1]
        .map((len) => digits.slice(0, len))
        .find((prefix) => callingCodeToIso[prefix]) || "55";
    }

    return callingCodeToIso[Number(code)] || callingCodeToIso[code] || "un";
  },
};

export default Parser;

